import { UserPlus } from 'lucide-react';
import { TenantUserListPhoto } from '../../../features/user/components/UserListPhoto';
import { formatInitials } from '../../../features/user/userDisplay';
import type { InvitableCompanyUser } from '../../../types/chatMember';

type ChatSessionShareInviteRowProps = {
  invitee: InvitableCompanyUser;
  translate: (key: string, params?: Record<string, string>) => string;
  onInvite: (userId: string) => Promise<void>;
};

export function ChatSessionShareInviteRow({
  invitee,
  translate,
  onInvite,
}: ChatSessionShareInviteRowProps) {
  return (
    <li className="liks-chat-share__list-item">
      <div className="liks-chat-share__row">
        <TenantUserListPhoto
          thumbnail={invitee.thumbnail}
          initials={formatInitials(invitee.name)}
          className="liks-chat-share__photo"
        />
        <div className="liks-chat-share__person">
          <span className="liks-chat-share__person-name">
            <span className="liks-chat-share__person-name-text">
              {invitee.name}
            </span>
          </span>
          <span className="liks-chat-share__person-meta">{invitee.email}</span>
        </div>
      </div>
      <div className="liks-chat-share__person-actions">
        <button
          type="button"
          className="liks-chat-share__action liks-chat-share__action--primary"
          aria-label={translate('chatSessions.shareInvite', {
            name: invitee.name,
          })}
          onClick={() => {
            void onInvite(invitee.userId).catch(() => undefined);
          }}
        >
          <UserPlus strokeWidth={2} aria-hidden />
          <span>{translate('chatSessions.shareInviteLabel')}</span>
        </button>
      </div>
    </li>
  );
}
